import { AuthRawReturn } from '@/modules/Auth/apiTypes/base'
import { APIRoute } from '@/modules/utils'

export type RequestBody = {
  email: string
}
export type RequestResponse = {
  success?: boolean
}

export const RequestRoute: APIRoute = {
  method: 'PUT',
  path: '/v2/magic_link/request',
}

export type SubmitBody = {
  magicLink: string
}
export type SubmitResponse = AuthRawReturn

export const SubmitRoute: APIRoute = {
  method: 'POST',
  path: '/v2/magic_link/submit',
}
